module.exports = __webpack_public_path__ + "faq/img/unget-task2.ea854c88.png";